module.exports = function() {
  return new Worker(__webpack_public_path__ + "214c87e78745f575d52e.worker.js");
};